import { useEffect, useRef } from 'react';
import { useI18n } from '../context/I18nContext';
import { useApp } from '../context/AppContext';

export default function PendingScreen({ onLogout }) {
  const { t, lang, switchLang } = useI18n();
  const { setShowHelp } = useApp();
  const headingRef = useRef(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="setup-screen auth-screen" role="main" aria-label={t('pendingTitle')}>
      <div className="setup-card" style={{ maxWidth: '480px', textAlign: 'center' }}>
        <div className="login-top-bar">
          <img src="/logo-cogency.png" alt="Cogency" className="login-top-logo" />
          <div className="lang-switcher" role="group" aria-label={t('language')}>
            <button className={lang === 'en' ? 'active' : ''} onClick={() => switchLang('en')} aria-pressed={lang === 'en'}>EN</button>
            <button className={lang === 'fr' ? 'active' : ''} onClick={() => switchLang('fr')} aria-pressed={lang === 'fr'}>FR</button>
            <button className={lang === 'ar' ? 'active' : ''} onClick={() => switchLang('ar')} aria-pressed={lang === 'ar'}>عربي</button>
            <button className={lang === 'es' ? 'active' : ''} onClick={() => switchLang('es')} aria-pressed={lang === 'es'}>ES</button>
            <button className={lang === 'de' ? 'active' : ''} onClick={() => switchLang('de')} aria-pressed={lang === 'de'}>DE</button>
            <button className={lang === 'zh' ? 'active' : ''} onClick={() => switchLang('zh')} aria-pressed={lang === 'zh'}>中文</button>
          </div>
        </div>

        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '8px' }}>{t('pendingTitle')}</h3>
        <p style={{ fontSize: '14px', color: 'var(--text-muted)', marginBottom: '24px' }}>
          {t('pendingDesc')}
        </p>

        <button className="btn-secondary btn-large" onClick={onLogout} style={{ width: '100%' }}>
          {t('logout')}
        </button>

        <p style={{ textAlign: 'center', fontSize: '13px', marginTop: '16px' }}>
          <button className="btn-ghost" onClick={() => setShowHelp(true)} style={{ fontSize: '13px' }}>
            ❓ {t('howItWorks')}
          </button>
        </p>
      </div>
    </div>
  );
}
